import styles from "./ErrorCallout.module.css"

interface ErrorCalloutProps {
  children: React.ReactNode
  // Extra layout class from the calling page (e.g. margin) — the callout owns
  // its own colour/shape, the page owns where it sits.
  className?: string
}

// The single, polished error treatment shared across the admin surfaces: a
// left-accented red callout with an alert glyph. Every admin page routes its
// load- and action-failure messages through here so the UX reads the same
// wherever it appears. role="alert" announces it the moment it renders.
export function ErrorCallout({ children, className }: ErrorCalloutProps) {
  return (
    <div
      role="alert"
      className={className ? `${styles.callout} ${className}` : styles.callout}
    >
      <svg
        viewBox="0 0 20 20"
        className={styles.icon}
        aria-hidden="true"
        focusable="false"
      >
        <circle cx="10" cy="10" r="9" fill="currentColor" />
        <path
          d="M10 5.5v5.5"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <circle cx="10" cy="14.25" r="1.15" fill="#fff" />
      </svg>
      <div className={styles.message}>{children}</div>
    </div>
  )
}
